import EditTransaction from './EditTransaction';

const EditIncome = () => {
  return <EditTransaction transactionType="income" returnTo="/income" isRecurring={false}/>;
};

export default EditIncome;